import React from 'react';
import styled from 'styled-components';
import { CONS } from '@pomofocus/core';
import { DropDownWindow } from '../../../styles/DropDown';
import { Clickable } from '../../../styles/Animation';
import { CheckBoxMark } from '../../../styles/Form';
import detectOutsideClick from '../../../../modules/hooks/detectOutsideClick';
function getItemName(index) {
    switch (index) {
        case 0:
            return 'Pomodoro';
        case 1:
            return 'Short Break';
        default:
            return 'Long Break';
    }
}
export function ColorSelectDropdown({ visible, closeDropdown, onChange, activeItemIndex, colorThemes, top, left, right, dropdownRef, }) {
    detectOutsideClick(dropdownRef, closeDropdown, visible);
    const handleColorSelect = (themeId) => {
        onChange(themeId);
        closeDropdown();
    };
    return (React.createElement(DropdownContainer, null,
        React.createElement(DropdownWindow, { visible: visible, top: top, left: left, right: right },
            React.createElement(DropdownTitle, null,
                "Pick a color for ",
                getItemName(activeItemIndex)),
            React.createElement(ColorGrid, null, CONS.COLORS.THEME_IDS_LIST.map((themeId) => (React.createElement(ColorOption, { key: themeId, color: CONS.COLORS.THEME[themeId], onClick: () => handleColorSelect(themeId) },
                React.createElement(CheckBoxIcon, { isActive: colorThemes[activeItemIndex] === themeId }))))))));
}
const DropdownContainer = styled.div `
  position: relative;
`;
const DropdownWindow = styled.div `
  ${DropDownWindow}
  position: absolute;
  background-color: white;
  transform: ${(props) => `translateY(${props.top}px)`};
  width: 220px;
  max-width: 90vw;
  ${(props) => props.left !== undefined ? `left: ${props.left}px;` : ''}
  ${(props) => props.right !== undefined ? `right: ${props.right}px;` : ''}
  z-index: 1000;
`;
const DropdownTitle = styled.div `
  font-weight: bold;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 14px;
  text-align: center;
`;
const ColorGrid = styled.div `
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  gap: 8px;
  justify-content: center;
`;
const ColorOption = styled.div `
  ${Clickable}
  background-color: ${(props) => props.color};
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const CheckBoxIcon = styled.div `
  ${CheckBoxMark}
  display: none;
  position: absolute;
  transform: translate(-3px, -3px);

  ${(props) => props.isActive && 'display: block;'};
`;
